import React from 'react';
//import NumberFormat from 'react-number-format';
import { numberToCurrency } from '../../../utils/String';
import * as PropTypes from 'prop-types';

/**
 *
 * @param {Number} value
 * @param {'dollars' | 'cents'} currency
 * @param {String} htmlTag
 * @param {String} className
 * @returns {HTMLElement}
 * @constructor
 */
const CurrencyFormat = ({
  value,
  currency = 'cents',
  htmlTag = 'span',
  className
}) => {
  const toCents = currency === 'cents';
  const Tag = htmlTag;
  return (
    <Tag className={className} data-testid="currency-format-value">
      {numberToCurrency(value, toCents)}
    </Tag>
  );
};

CurrencyFormat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.oneOf(['dollars', 'cents']),
  htmlTag: PropTypes.string,
  className: PropTypes.string
};

export default CurrencyFormat;
